import { Tooltip as Tooltip$1 } from '@ubnt/ui-components/Tooltip';
import { styled, createGlobalStyle } from 'styled-components';
import { theme } from '../../constants/theme.mjs';
"use strict";
const TOOLTIP_CLASS_NAME = "custom-tooltip";
const Tooltip = styled(Tooltip$1)`
  display: flex;
`;
const TooltipStyles = createGlobalStyle`
  .${TOOLTIP_CLASS_NAME} {
    white-space: nowrap;
    z-index: ${theme.zIndex.header + 1}!important;
    border-radius: 8px;
    color: #808893;
    font-size: 14px;
    line-height: 20px;
    box-shadow: 0 0 1px 0 rgb(33 35 39 / 0.08), 0 12px 48px 0 rgb(33 35 39 / 0.12);
    background-color: #fff;
    padding: 16px;

    * {
      color: #808893;
      font-size: 14px;
      line-height: 20px;
    }

    &::before {
      background-color: #fff;
      box-shadow: -4px -4px 4px -4px rgb(33 35 39 / .08);
    }
  }
`;
export { TOOLTIP_CLASS_NAME, Tooltip, TooltipStyles };
//# sourceMappingURL=Tooltip.styles.mjs.map
